import { render, staticRenderFns } from "./DepartmentForm.vue?vue&type=template&id=53d1d3f2&scoped=true"
import script from "./DepartmentForm.vue?vue&type=script&lang=js"
export * from "./DepartmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d1d3f2",
  null
  
)

export default component.exports